import { AcquiringItem } from 'app/dataTypes/acquiring/settings'

export function useAcquiringItemByID(ID: string | null, items: Map<string, AcquiringItem>) {
  if (!ID) return null
  return items.get(ID) || null
}
